"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const services_1 = require("../../../services");
const ProductCardShop_styled_1 = require("./ProductCardShop.styled");
const PRONTA_ENTREGA = 'Pronta-entrega';
const redirect = (url, label) => {
    services_1.GoogleAnalyticsService.event({
        event: 'ga-event',
        'event-action': 'click:button',
        'event-category': 'enhanced-ecommerce',
        'event-label': label || '',
    });
    window.setTimeout(() => {
        window.location.href = url;
    }, 300);
};
const CustomTag = ({ data, slug, hasDiscount }) => {
    const defaultConfigs = {
        shape: data.includes('%') ? 'ghost' : 'solid',
        size: 'small',
        role: 'link',
        variant: 'primary',
    };
    const linkConfig = {
        css: {
            cursor: 'pointer',
        },
    };
    if (data.toLowerCase() === PRONTA_ENTREGA.toLowerCase()) {
        return ((0, jsx_runtime_1.jsx)(ProductCardShop_styled_1.TagStyled, Object.assign({}, defaultConfigs, linkConfig, { onClick: () => redirect(`/${slug}/pronta-entrega`, 'pronta-entrega') }, { children: data })));
    }
    if (hasDiscount && data.includes('%')) {
        return ((0, jsx_runtime_1.jsx)(ProductCardShop_styled_1.TagStyled, Object.assign({}, defaultConfigs, linkConfig, { onClick: () => redirect(`/${slug}/categoria?category=promocao`, 'promoções') }, { children: data })));
    }
    return (0, jsx_runtime_1.jsx)(ProductCardShop_styled_1.TagStyled, Object.assign({}, defaultConfigs, { children: data }));
};
exports.CustomTag = CustomTag;
